import { BaseRestfulService } from "./base";
import { ServiceURL } from "./url";

export class AuthService extends BaseRestfulService {
  async login({ account, password }) {
    return this.post(ServiceURL.auth.login(), {
      account,
      password,
    });
  }

  async logout() {
    return this.post(ServiceURL.auth.logout(), {});
  }
}
